module.exports = __webpack_public_path__ + "static/media/Vertical-Dark-Nav-Layout.3336b09a.png";